module.exports = __webpack_public_path__ + "img/PorQue_Mobile@1x.8de2418.webp";